import { getScrollContainer } from '@theme/scroll-container';

const DESKTOP_QUERY = window.matchMedia('(min-width: 1280px)');
const REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');
const PREVIEW_ANIMATION_DURATION = 300;

class MissionBrandStory extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('mouseover', this.handleMouseOver);
    this.addEventListener('mouseout', this.handleMouseOut);
    this.addEventListener('focusin', this.handleFocusIn);
    this.addEventListener('focusout', this.handleFocusOut);
    this.addEventListener('mouseleave', this.handleMouseLeave);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('mouseover', this.handleMouseOver);
    this.removeEventListener('mouseout', this.handleMouseOut);
    this.removeEventListener('focusin', this.handleFocusIn);
    this.removeEventListener('focusout', this.handleFocusOut);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
  }

  openItem(item) {
    if (!DESKTOP_QUERY.matches || !(item instanceof HTMLDetailsElement) || item.open) return;
    this.querySelectorAll('[data-mission-story-item][open]').forEach((openItem) => {
      if (openItem !== item) this.closeItem(openItem);
    });
    item.setAttribute('open', '');
    this.animatePreview(item);
  }

  animatePreview(item) {
    if (REDUCED_MOTION_QUERY.matches) return;
    item.querySelectorAll('.mission-brand-value__preview > *').forEach((content) => {
      content.getAnimations().forEach((animation) => animation.cancel());
      content.animate(
        [
          { opacity: 0, transform: 'translateY(12px)' },
          { opacity: 1, transform: 'translateY(0)' },
        ],
        {
          duration: PREVIEW_ANIMATION_DURATION,
          easing: 'ease',
          fill: 'both',
        }
      );
    });
  }

  closeItem(item) {
    if (!(item instanceof HTMLDetailsElement) || !item.open) return;
    item.querySelectorAll('.mission-brand-value__preview > *').forEach((content) => {
      content.getAnimations().forEach((animation) => animation.cancel());
    });
    item.removeAttribute('open');
  }

  closeAll() {
    if (!DESKTOP_QUERY.matches) return;
    this.querySelectorAll('[data-mission-story-item][open]').forEach((item) => this.closeItem(item));
  }

  handleClick = (event) => {
    if (DESKTOP_QUERY.matches || !(event.target instanceof Element)) return;
    const summary = event.target.closest('.mission-brand-value__summary');
    const item = summary?.closest('[data-mission-story-item]');
    if (!(item instanceof HTMLDetailsElement)) return;
    event.preventDefault();
    const top = summary.getBoundingClientRect().top;
    const opening = !item.open;
    this.querySelectorAll('[data-mission-story-item][open]').forEach((openItem) => this.closeItem(openItem));
    item.open = opening;
    const scrollContainer = getScrollContainer();
    scrollContainer.scrollTo({
      top: scrollContainer.scrollTop + summary.getBoundingClientRect().top - top,
      behavior: 'instant',
    });
  };

  handleMouseOver = (event) => {
    if (!(event.target instanceof Element)) return;
    this.openItem(event.target.closest('[data-mission-story-item]'));
  };

  handleMouseOut = (event) => {
    if (!DESKTOP_QUERY.matches) return;
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest('[data-mission-story-item]');
    const nextItem = event.relatedTarget instanceof Element
      ? event.relatedTarget.closest('[data-mission-story-item]')
      : null;
    if (item !== nextItem) this.closeItem(item);
  };

  handleFocusIn = (event) => {
    if (!(event.target instanceof Element)) return;
    this.openItem(event.target.closest('[data-mission-story-item]'));
  };

  handleFocusOut = (event) => {
    if (!this.contains(event.relatedTarget)) this.closeAll();
  };

  handleMouseLeave = () => {
    if (!this.contains(document.activeElement)) this.closeAll();
  };
}

if (!customElements.get('mission-brand-story')) {
  customElements.define('mission-brand-story', MissionBrandStory);
}
